<template>
  <div class="text-[14px] leading-[22px] text-gray-800">
    <div class="mb-[14px]">{{ subtitle }}</div>

    <div v-if="loading" class="flex justify-center py-6">
      <Spinner :size="24" />
    </div>

    <div v-else class="max-h-[330px] overflow-y-auto overscroll-contain">
      <div
        v-for="entity in entities"
        :key="entity.id"
        class="flex h-10 items-center border-b border-[#efefef]"
      >
        <Avatar :src="entity.avatarUrl" :size="24" class="mr-2.5" />
        <div class="text-[14px] leading-[18px] text-gray-800">
          {{ entity.name }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Avatar } from '@dacr/library'

import Spinner from '@/shared/components/Spinner.vue'
import type { EntityListItem } from './useAllEntities'

defineProps<{
  subtitle: string
  entities: EntityListItem[]
  loading: boolean
}>()
</script>
